import { PromoFormProps } from '@design-system/promo-form-block';

import { PromoFormCSProps, ThankYouProps } from '~/components/PromoForm/models';
import { headingBlockMapper } from '~/mappers/headingBlock';
import { imageMapper } from '~/mappers/image';
import { pageBlockUIMapper } from '~/mappers/pageBlock';

import { Form, PromoForm, ThankYou } from './models';

const formMapper = ({
  formId,
  submitErrorMessage,
  showHeading,
  thankYouPageRedirect,
}: Form): PromoFormProps => ({
  url: process.env.GATSBY_PROMO_PLATFORM_URL || '',
  formId,
  submitErrorMessage,
  showHeading,
  thankYouPageRedirect,
});

const thankYouMapper = ({
  closeButtonAriaLabel,
  heading,
  image,
}: ThankYou): Omit<ThankYouProps, 'closeHandler'> =>
  ({
    closeButtonLabel: closeButtonAriaLabel,
    heading: headingBlockMapper(heading),
    image: imageMapper(image),
  } as Omit<ThankYouProps, 'closeHandler'>);

export const promoFormMapper = ({
  pageBlockUI,
  componentId,
  heading,
  form,
  thankYou,
  uid,
}: PromoForm): PromoFormCSProps => ({
  pageBlockUI: pageBlockUIMapper(pageBlockUI[0].ui),
  componentId,
  heading: headingBlockMapper(heading),
  form: formMapper(form),
  thankYou: thankYouMapper(thankYou),
  uid,
});
